export const teamLikeFields = ['division', 'region', 'management-level'];

export const userImportFields: Record<string, { aliases: string[]; label: string }> = {
  name: {
    aliases: ['name'],
    label: 'Name',
  },
  email: {
    aliases: ['email'],
    label: 'Email',
  },
  roles: {
    aliases: ['role', 'roles'],
    label: 'Roles',
  },
  division: {
    aliases: ['division', 'department'],
    label: 'Division',
  },
  region: {
    aliases: ['region'],
    label: 'Region',
  },
  managementLevel: {
    aliases: ['management level'],
    label: 'Management Level',
  },
  insight: {
    aliases: ['insight'],
    label: 'Insight',
  },
  prevent: {
    aliases: ['prevent'],
    label: 'Prevent',
  },
};

export default userImportFields;
